export const dicOptions = {
  validStatus: [
    { value: 0, label: '已过期' },
    { value: 1, label: '生效中' },
    { value: 2, label: '待生效' }
  ],
  unit: [
    { value: 1, label: '金额' },
    { value: 2, label: '次数' },
    { value: 3, label: '条数' }
  ]
}

export const tableColumns = [
  {
    key: 1,
    title: '供应商',
    filed: 'merchantName',
    width: 180
  },
  {
    key: 2,
    title: '应用类型',
    filed: 'tripartiteResourceName',
    width: 180
  },
  {
    key: 3,
    title: '状态',
    filed: 'statusName',
    width: 180
  },
  {
    key: 4,
    title: '用户',
    filed: 'user',
    width: 180
  },
  {
    key: 5,
    title: '时间',
    filed: 'createTime',
    width: 180
  },
  {
    key: 6,
    title: '内容',
    filed: 'linkRecordId'
  },
  {
    key: 7,
    title: '次/条',
    filed: 'num'
  },
  {
    key: 8,
    title: '费用(元)',
    filed: 'price'
  }
]

export const ruleLogTableColumns = [
  {
    key: 3,
    title: '生效时间',
    filed: 'effectDate'
  },
  {
    key: 4,
    title: '添加人',
    filed: 'createUserName'
  },
  {
    key: 5,
    title: '添加时间',
    filed: 'createTime'
  },
  {
    key: 6,
    title: '状态',
    filed: 'validStatusName'
  }
]

export const rechargeLogTableColumns = [
  {
    label: '操作时间',
    prop: 'createTime',
    align: 'center'
  },
  {
    label: '服务商',
    align: 'center',
    prop: 'supplierName'
  },
  {
    label: '充值量',
    align: 'center',
    prop: 'rechargeNum'
  },
  {
    label: '操作人',
    align: 'center',
    prop: 'createUserName'
  }
]

export const priceConifTableColumns = [
  {
    filed: 'validStartDate',
    title: '生效时间',
    width: 180
  },
  {
    filed: 'supplierId',
    title: '服务商'
  },
  {
    filed: 'totalNum',
    title: '余量类型',
    width: 220
  },
  {
    filed: 'validEndDate',
    title: '到期时间',
    width: 180
  },
  {
    filed: 'warnNum',
    title: '警戒值'
  }
]
